<template>
  <b-button :disabled="disabled" @click="emit">
    {{name}}
  </b-button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    name: {
      type: String,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    emit() {
      this.$emit('event')
    }
  }
}
</script>

<style lang="scss">

.level-right{
  button{
  margin-left: 0.2rem;
  background: #2D9CDB;
  border-radius: 4px;
  color: #fff;
  text-transform: uppercase;
  color: #fff;
 }
}
</style>
